import axios from 'axios';

export default axios.create({
    headers: { 'X-Api-Key': process.env.REACT_APP_API_KEY_SECRET },
    baseURL: process.env.REACT_APP_API
});

export const isAxiosError = axios.isAxiosError;
